/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import { v4 } from "uuid";
import Markdown from "markdown-to-jsx";

const tableContainerClass = css`
  color: white;
  .MuiTableCell-root {
    border: 1px solid rgba(224, 224, 224, 1);
  }
  .MuiTableHead-root {
    background-color: grey;
  }
`;
const descriptionWrapper = css`
  font-size: 14px;
  line-height: 35px;
`;
const fontFamilyWrapper = (theme) => css`
  font-family: ${theme.typography.MBCORPOA};
`;
export default function DynamicTable({ tableData, description }) {
  const [tableValue, setTableValue] = useState(null);
  const [max, setMax] = useState(0);

  useEffect(() => {
    const obj = {};
    let count = 0;
    tableData?.column?.map((item) => {
      obj[item.columnName] = item?.element?.map((ele) => ele?.rowValue);
      if (count < item?.element?.length) {
        count = item?.element?.length;
      }
    });
    setTableValue((prevState) => ({
      ...prevState,
      ...obj,
    }));
    setMax(count);
  }, [tableData]);

  return (
    <TableContainer css={tableContainerClass}>
      <Typography gutterBottom variant="h6" css={fontFamilyWrapper}>
        {tableData?.title}
      </Typography>
      <Typography gutterBottom mb={2} variant="body2">
        <Markdown css={descriptionWrapper}>{description || ""}</Markdown>
      </Typography>
      <Table style={{ color: "white" }}>
        <TableHead>
          <TableRow>
            {tableData?.column?.map((item) => (
              <TableCell key={v4()} style={{ color: "white" }}>
                {item?.columnName}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(max)].map((ele, index) => (
            <TableRow key={v4()}>
              {Object.keys(tableValue).map((item) => (
                <TableCell key={v4()} style={{ color: "white" }}>
                  {tableValue?.[item][index]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
